import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { messages } from '../../constants/Podcasts';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRetired } from '../../lib/RightsUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import PodcastProgramMetadata from '../PodcastProgramMetadata/PodcastProgramMetadata';

import CatalogRowItem from './CatalogRowItem';

/*
 * PodcastProgramRowItem is for rendering T3 podcast program row items.
 *
 * See CatalogRowItem and lib/GridItem for additional available props.
 */
class PodcastProgramRowItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    secondText: PropTypes.string,
    episodeCount: PropTypes.number,
    collectedEpisodeCount: PropTypes.number,
    showNewBadge: PropTypes.bool,
    showCollectedBadge: PropTypes.bool,
    isMixedWithOtherSources: PropTypes.bool,
    isClickableRow: PropTypes.bool,
    intl: PropTypes.object,
  };

  static defaultProps = {
    pandoraType: PandoraTypes.PODCAST,
  };

  render() {
    const {
      episodeCount,
      collectedEpisodeCount,
      showNewBadge,
      isMixedWithOtherSources,
      isClickableRow,
    } = this.props;
    const thirdText = this.props.intl.formatMessage(messages.episodeCount, {
      count: episodeCount,
    });

    return (
      <CatalogRowItem
        rightColChild={
          !isClickableRow && (
            <PodcastProgramMetadata
              episodeCount={episodeCount}
              collectedEpisodeCount={collectedEpisodeCount}
              showNewBadge={showNewBadge}
              showSourceName={isMixedWithOtherSources}
            />
          )
        }
        thirdText={isClickableRow && thirdText}
        {...this.props}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const id = ownProps.id;
  const details = getAnnotationsById(state, id);
  props.blankItem = !details;
  if (details && id) {
    const backstageUrl = details.get('shareableUrlPath');
    props.mainText = details.get('name');
    props.mainTextUrl = !ownProps.isClickableRow && backstageUrl;
    props.rowUrl = ownProps.isClickableRow && backstageUrl;
    props.secondText = details.get('publisherName');
    props.dominantColor = getDominantColor(details);
    props.imgUrl = getArt(details, 90, state, PandoraTypes.PODCAST);
    props.isPlayingCurrently = getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      id,
    );
    props.isPaused =
      !getInDomain('playback.utils.isAudioPlaying')(state) && props.isPlayingCurrently;
    props.episodeCount = details.get('episodeCount');
    props.showNewBadge = getInDomain('playback.utils.shouldPodcastShowNewBadge', null)(state, id);
    props.isCollected =
      ownProps.showCollectedBadge &&
      getInDomain('collection.utils.isPandoraIdInCollection', false)(state, id);
    props.isRetired = isRetired(details);

    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: id,
      pandoraType: PandoraTypes.PODCAST,
      shareParentSource: {
        shareParentSourceId: id,
        shareParentSourceType: PandoraTypes.PODCAST,
      },
    });
  }
  return props;
}

const enhance = compose(
  // We use injectIntl here because there was some inexplicable performance issues when using <FormattedMessage> directly in the props
  injectIntl,
  connect(mapStateToProps, null),
);

export default enhance(PodcastProgramRowItem);
export { PodcastProgramRowItem as PurePodcastProgramRowItem };
